import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
// import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect, useState } from "react";
import HomePage from "./pages/HomePage";
import SchemeRegistration from "../src/components/Master/SchemeRegistration/SchemeRegistration";
import SchemeCashReceipt from "../src/components/Entry/SchemeReceipt/SchemeCashReceipt";
import SchemeRedeem from "./components/Entry/SchemeRedeem/SchemeRedeem";
import HomePageMob from "./pages/HomePageMob";
import SchemeRegistrationMob from "../src/components/Master/SchemeRegistration/SchemeRegistrationMob";
import LedgerReg from "./components/Master/AccountRegistration/LedgerRegistration/LedgerReg";
import SchemeReport from "./components/AccountReports/SchemeReports/SchemeReport";
import LoginPage from "./pages/LoginPage";
import SignUp from "./pages/SignUp";
import StaffReg from "./components/Master/OtherRegistartion/StaffRegistration/StaffReg";
import SchemeCashReceiptMob from "../src/components/Entry/SchemeReceipt/SchemeCashReceiptMob";
import Print from "./components/PrintModels/Print";
import PrintMob from "./components/PrintModels/PrintMob";
import AuthProvider from "./context/AuthContext";
import { DbProvider } from "./context/DbContext";
import ProtectedRoute from "./routes/ProtectedRoute";
import RateClassReg from "./components/Master/OtherRegistartion/RateclassRegistration/RateClassReg";
import RateSettings from "./components/Master/RateSettings/RateSettings";
import ReceiptList from "./components/AccountReports/ReceiptList/ReceiptList";
import FormRegistration from "./components/File/FormRegistration/FormRegistration";
import DayBook from "./components/AccountReports/DayBook/DayBook";
import DayBookReport from "./components/AccountReports/DayBook/DayBookReport";
import JournalEntry from "./components/Entry/JournalEntry/JournalEntry";
import ContraEntry from "./components/Entry/ContraEntry/ContraEntry";
import LedgerRepModel from "./components/AccountReports/LedgerReport/LedgerRepModel";
import LedgerReport from "./components/AccountReports/LedgerReport/LedgerReport";
import CreateDb from "./pages/CreateDb";
import CreateCompany from "./components/Cdb/CreateCompany";
import QuickSearch from "./components/QuickSearch";
import StaffRegMob from "./components/Master/OtherRegistartion/StaffRegistration/StaffRegMob";
import AgentReport from "./components/AccountReports/AgentReport/AgentReport";
import LedgerRegMob from "./components/Master/AccountRegistration/LedgerRegistration/LedgerRegMob";
import DbUpdateManager from "./components/DbUpdateManager/DbUpdateManager";
import CheckTablesQueryGenerator from "./components/CheckTablesQueryGenerator/CheckTablesQueryGenerator";

import AgentReportModel from "./components/AccountReports/AgentReport/AgentReportModel";
import "@fontsource/inter"; // Defaults to weight 400
import "@fontsource/inter/400.css"; // Specify weight
import "@fontsource/inter/400-italic.css"; // Specify weight and style
import OpenCompany from "./components/Cdb/OpenCompany";
import OpenCompanyMob from "./pages/OpenCompanyMob";
import EmailVerification from "./components/verificators/EmailVerification";
import SmsSettings from "./components/SmsSettings";
import CustomerCodeVerification from "./components/Cdb/CustomerCodeVerification";
// import Receipt from './components/CashReceipt';
import CashReceipt from "../src/components/Entry/Receipt/CashReceipt";
import WhatsAppSettings from "./components/WhatsAppSettings";
import LedgerList from "./components/RecordList/LedgerList/LedgerList";

import RenameLedger from "./components/RenameLedger/RenameLedger";
import CashPayment from "../src/components/Entry/Payment/CashPayment";
import ProductReg from "./components/Master/ProductRegistration/ProductReg";
import SchemeOverDue from "./components/RecordList/SchemeOverDueList/SchemeOverDue";
import PurchaseEntry from "./components/Entry/Purchase/PurchaseEntry";
import PasswordVerification from "./components/verificators/PasswordVerification";
import SchemeReportDia from "./components/AccountReports/SchemeReports/SchemeReportDia";
import EventDetails from "./components/RecordList/EventDetails/EventDetails";
import EventDetailsReport from "./components/RecordList/EventDetails/EventDetailsReport";
import ImportReceipt from "./components/Entry/SchemeReceipt/ImportReceipt";
import UpiPayment from "./components/Entry/UPI/UpiPayment";
import TransferVoucher from "./components/Entry/TransferVoucher/TransferVoucher";
import CreateUser from "./components/Master/CreateUser/CreateUser";
import { WebSocketProvider } from "./context/WebSocketContext";
// import 'normalize.css';

import { useSelector } from "react-redux";
import { selectGeneralSettings } from "./app/settingsSlice";
import { APP_VERSION } from "./config/version";
import { useAppVersionSync } from "./hooks/useAppVersionSync";
import axios from "axios";

const isInternalApiUrl = (url) => {
  if (!url) return false;
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  if (apiBaseUrl && url.startsWith(apiBaseUrl)) return true;
  if (url.startsWith("/") || url.startsWith("http://localhost") || url.startsWith("https://localhost")) return true;
  if (!url.startsWith("http://") && !url.startsWith("https://")) return true;
  return false;
};

// Add global axios interceptor to automatically attach authorization header with JWT for internal requests
axios.interceptors.request.use(
  (config) => {
    if (isInternalApiUrl(config.url)) {
      const token = sessionStorage.getItem("authToken") || localStorage.getItem("authToken");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add global response interceptor to handle token expiry / invalidation (401/403 errors) for internal requests
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const requestUrl = error.config ? error.config.url : "";
    const isUnauthEndpoint =
      requestUrl.includes('/verify-password') ||
      requestUrl.includes('/userLogin') ||
      requestUrl.includes('/otherregistration/getoptions') ||
      requestUrl.includes('/main/getalldatabases');
    const isUnauthPage = window.location.pathname === '/login' || window.location.pathname === '/';

    if (
      isInternalApiUrl(requestUrl) &&
      !isUnauthEndpoint &&
      !isUnauthPage &&
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      // Clear token and authentication details from storage
      sessionStorage.removeItem("authToken");
      sessionStorage.removeItem("agentCode");
      sessionStorage.removeItem("userType");
      sessionStorage.removeItem("dbCode");
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("Uaccno");
      
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("agentCode");
      localStorage.removeItem("uRights");
      localStorage.removeItem("authToken");
      localStorage.removeItem("userId");
      localStorage.removeItem("userType");
      localStorage.removeItem("CustomerName");
      localStorage.removeItem("Uaccno");
      
      // Notify the user and redirect to appropriate screen
      const storedDbCode = localStorage.getItem("dbCode");
      if (storedDbCode) {
        alert("Your session has expired or is invalid. Please log in again.");
        window.location.href = "/login";
      } else {
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

function App() {
  // const isMobile = window.innerWidth < 768;
  useAppVersionSync();

  const GeneralSettings = useSelector(selectGeneralSettings);
  const [inputFocusColor, setInputFocusColor] = useState("#FFD700");

  // ----version wise data loaders-----

  // ---------------------------------

  useEffect(() => {
    // Extract input color from settings
    if (GeneralSettings.length > 0) {
      const inputColorSetting = GeneralSettings.find(
        (setting) => setting.Name === "INPUT COLOUR"
      );
      if (inputColorSetting && inputColorSetting.s_Value) {
        setInputFocusColor(inputColorSetting.s_Value);
      }
    }
  }, [GeneralSettings]);

  // Apply the color as CSS variable
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--input-focus-color",
      inputFocusColor
    );
  }, [inputFocusColor,APP_VERSION]);

  const isMobileOrTablet = window.innerWidth < 1024;
  // Check if dbCode exists
  const dbCode = localStorage.getItem("dbCode");
  const hasDbCode = !!dbCode;
  return (
    <div className="App">
      <AuthProvider>
        <DbProvider>
          <WebSocketProvider>
            <Router>
              <Routes>
                <Route
                  path="/"
                  element={
                    hasDbCode ? (
                      <Navigate to="/login" replace />
                    ) : isMobileOrTablet ? (
                      <OpenCompanyMob />
                    ) : (
                      <CreateDb />
                    )
                  }
                />
                <Route path="/createcompany" element={<CreateCompany />} />
                <Route
                  path="/opencompany"
                  element={<ProtectedRoute element={<OpenCompany />} />}
                />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/verifyemail" element={<EmailVerification />} />
                <Route path="/cdbsettings" element={<CustomerCodeVerification />} />
                <Route path="/dbupdate" element={<DbUpdateManager />} />
                <Route path="/checktables-generator" element={<CheckTablesQueryGenerator />} />

                <Route
                  path="/signUp"
                  element={<ProtectedRoute element={<SignUp />} />}
                />

                {isMobileOrTablet ? (
                  <Route
                    path="/home"
                    element={<ProtectedRoute element={<HomePageMob />} />}
                  />
                ) : (
                  <Route
                    path="/home"
                    element={<ProtectedRoute element={<HomePage />} />}
                  />
                )}

                {isMobileOrTablet ? (
                  <Route
                    path="/registration"
                    element={
                      <ProtectedRoute element={<SchemeRegistrationMob />} />
                    }
                  />
                ) : (
                  <Route
                    path="/registration"
                    element={
                      <ProtectedRoute element={<SchemeRegistration />} />
                    }
                  />
                )}

                <Route
                  path="/receiptmob"
                  element={
                    <ProtectedRoute element={<SchemeCashReceiptMob />} />
                  }
                />

                {isMobileOrTablet ? (
                  <Route
                    path="/receipt"
                    element={
                      <ProtectedRoute element={<SchemeCashReceiptMob />} />
                    }
                  />
                ) : (
                  <Route
                    path="/receipt"
                    element={<ProtectedRoute element={<SchemeCashReceipt />} />}
                  />
                )}

                <Route
                  path="/redeem"
                  element={<ProtectedRoute element={<SchemeRedeem />} />}
                />
                <Route
                  path="/ledger"
                  element={<ProtectedRoute element={<LedgerReg />} />}
                />
                
                <Route
                  path="/staffreg"
                  element={<ProtectedRoute element={<StaffReg />} />}
                />
                <Route
                  path="/staffregmob"
                  element={<ProtectedRoute element={<StaffRegMob />} />}
                />

                <Route
                  path="/report"
                  element={<ProtectedRoute element={<SchemeReport />} />}
                />

              
                <Route
                  path="/print"
                  element={<ProtectedRoute element={<Print />} />}
                />
                <Route
                  path="/printMob"
                  element={<ProtectedRoute element={<PrintMob />} />}
                />
                <Route
                  path="/rateClass"
                  element={<ProtectedRoute element={<RateClassReg />} />}
                />
                <Route
                  path="/rateSettings"
                  element={<ProtectedRoute element={<RateSettings />} />}
                />
                <Route
                  path="/receiptList"
                  element={<ProtectedRoute element={<ReceiptList />} />}
                />
                <Route
                  path="/formReg"
                  element={<ProtectedRoute element={<FormRegistration />} />}
                />
                <Route
                  path="/dayBook"
                  element={<ProtectedRoute element={<DayBook />} />}
                />
                <Route
                  path="/daybookreport"
                  element={<ProtectedRoute element={<DayBookReport />} />}
                />
                <Route
                  path="/jventry"
                  element={<ProtectedRoute element={<JournalEntry />} />}
                />
                <Route
                  path="/cventry"
                  element={<ProtectedRoute element={<ContraEntry />} />}
                />
                <Route
                  path="/ledgerdia"
                  element={<ProtectedRoute element={<LedgerRepModel />} />}
                />
                <Route
                  path="/ledgerreport"
                  element={<ProtectedRoute element={<LedgerReport />} />}
                />
                <Route
                  path="/qsearch"
                  element={<ProtectedRoute element={<QuickSearch />} />}
                />
                <Route
                  path="/agreport"
                  element={<ProtectedRoute element={<AgentReport />} />}
                />
                <Route
                  path="/agreportdia"
                  element={<ProtectedRoute element={<AgentReportModel />} />}
                />
                <Route
                  path="/smssettings"
                  element={<ProtectedRoute element={<SmsSettings />} />}
                />
                <Route
                  path="/wtssettings"
                  element={<ProtectedRoute element={<WhatsAppSettings />} />}
                />

                <Route
                  path="/cashreceipt"
                  element={<ProtectedRoute element={<CashReceipt />} />}
                />
                <Route
                  path="/cashpayment"
                  element={<ProtectedRoute element={<CashPayment />} />}
                />
                <Route
                  path="/purchaseEntry"
                  element={<ProtectedRoute element={<PurchaseEntry />} />}
                />

                <Route
                  path="/ledgerlist"
                  element={<ProtectedRoute element={<LedgerList />} />}
                />

                <Route
                  path="/renameLed"
                  element={<ProtectedRoute element={<RenameLedger />} />}
                />
                <Route
                  path="/productReg"
                  element={<ProtectedRoute element={<ProductReg />} />}
                />
                <Route
                  path="/schoverdue"
                  element={<ProtectedRoute element={<SchemeOverDue />} />}
                />
                <Route
                  path="/ledmob"
                  element={<ProtectedRoute element={<LedgerRegMob />} />}
                />
                <Route
                  path="/pverify"
                  element={
                    <ProtectedRoute element={<PasswordVerification />} />
                  }
                />
                <Route
                  path="/schrepdia"
                  element={<ProtectedRoute element={<SchemeReportDia />} />}
                />
                <Route
                  path="/eventdetails"
                  element={<ProtectedRoute element={<EventDetails />} />}
                />
                <Route
                  path="/eventreport"
                  element={<ProtectedRoute element={<EventDetailsReport />} />}
                />
                <Route
                  path="/importrec"
                  element={<ProtectedRoute element={<ImportReceipt />} />}
                />
                <Route
                  path="/transferpv"
                  element={<ProtectedRoute element={<TransferVoucher />} />}
                />

                <Route
                  path="/upipayment"
                  element={<ProtectedRoute element={<UpiPayment />} />}
                />
                <Route
                  path="/createuser"
                  element={<ProtectedRoute element={<CreateUser />} />}
                />
              </Routes>
            </Router>
          </WebSocketProvider>
        </DbProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
